// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type * as Types from '../util-types.js';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PublicSiteQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type PublicSiteQuery = {
  publicSite?: {
    __typename: 'PublicSite';
    id: string;
    platformId: string;
    name: string;
    domain: string;
    logoUrl?: string | null;
    enableSiteAssistant: boolean;
    siteAssistantFormId?: string | null;
  } | null;
};

export const PublicSiteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicSite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicSite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platformId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enableSiteAssistant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'siteAssistantFormId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicSiteQuery, PublicSiteQueryVariables>;
